import styled from 'styled-components';

const breakpoints = {
  tablet: '768px',
  mobile: '480px',
};

export const LayoutWrapper = styled.div`
  display: flex;
  flex: 1 0 auto;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: 8px;

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
  }
`;

export const BackgroundWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 200px;
  background-image: url('https://s3.us-east-1.amazonaws.com/com.lqa.v5.images.dev/popup-message/bg_image.png');
  background-size: cover;
  background-position: center;

  @media (max-width: ${breakpoints.mobile}) {
    height: 150px;
  }
`;

export const OverlayContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: flex-start;
  justify-content: space-between;
  overflow: visible;

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const LogoContainer = styled.div`
  flex: 3;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  height: 100%;
  margin: 0 30px;

  @media (max-width: ${breakpoints.mobile}) {
    margin: 0 16px;
  }
`;

export const LogoImage = styled.img`
  padding-top: 20px;
  width: 70%;
  object-fit: cover;

  @media (max-width: ${breakpoints.tablet}) {
    width: 80%;
  }

  @media (max-width: ${breakpoints.mobile}) {
    width: 100%;
  }
`;

export const StyledImage = styled.img<{ flex?: number }>`
  flex: ${({ flex }) => flex || 1};
  max-height: 120%;
  max-width: 23%;

  @media (max-width: ${breakpoints.tablet}) {
    display: none;
  }
`;

export const PopUpWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 64px 0 32px 64px;

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
    padding: 32px 16px;
    height: auto;
  }
`;

export const ParagraphContainer = styled.div`
  flex: 2;
  text-align: left;
  padding-right: 40px;

  @media (max-width: ${breakpoints.tablet}) {
    padding-right: 0;
    margin-bottom: 32px;
  }
`;

export const ImageBoxContainer = styled.div`
  flex: 2;
  display: flex;
  align-items: center;
  max-width: 100%;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  overflow: hidden;

  @media (max-width: ${breakpoints.tablet}) {
    justify-content: center;
  }
`;

export const BoxImage = styled.img`
  width: 100%;
  height: 250px;
  object-fit: cover;

  @media (max-width: ${breakpoints.tablet}) {
    width: 80%;
  }

  @media (max-width: ${breakpoints.mobile}) {
    width: 100%;
  }
`;

export const CloseIconContainer = styled.div`
  position: absolute;
  top: 10px;
  right: 16px;
  z-index: 2;
  padding: 4px;
  cursor: pointer;
`;

export const ParagraphHeading = styled.h2`
  margin: 0 0 30px 0;
  font-weight: 500;
  font-size: 24px;
  font-family: 'Urbane', sans-serif;
  color: #091E3D;
  line-height: 30px;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 20px;
  }
`;

export const ParagraphIntro = styled.p`
  margin: 0 0 30px 0;
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  line-height: 25px;
  color: #091E3D;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 15px;
  }
`;

export const ButtonContainer = styled.div`
  width: 75%;
  margin-left: 20px;
`;
